import React from "react";
import { useEditor } from "@smartfire/wordpress-react";
import {MediaUpload, MediaUploadCheck} from '@wordpress/block-editor';
import { RichText } from '@wordpress/block-editor';
import {ReactComponent as SVGDefault} from './image.svg';
import style from './block.module.scss';

export const PictoLibelle = (props) => {

    const { smartProp, svgLibelle } = props;
    const { isEditing, updateData } = useEditor();

    function updateValue(key, value, i) {
        svgLibelle[i][key] = value;
        if (smartProp === "svgLibelle") updateData({svgLibelle: [...svgLibelle]})
        else updateData({svgLibelle2: [...svgLibelle]})
    }
    const addElement = () => {
        let newElement = {
            picture: '',
            libelle: 'libelle'
        }
        if (smartProp === "svgLibelle") updateData({svgLibelle: [...svgLibelle, newElement]});
        else updateData({svgLibelle2: [...svgLibelle, newElement]})
    }
    const deleteSlide = (i) => {
        svgLibelle.splice(i, 1);
        if (smartProp === "svgLibelle") updateData({svgLibelle: [...svgLibelle]});
        else updateData({svgLibelle2: [...svgLibelle]})
    }

    return <div className={`${style.container} ${isEditing && style.admin}`} smartProp={smartProp}>
        {isEditing && svgLibelle.map((item, i) => (
            <div key={i}>
                <div className={style.content}>
                    {item.picture ? <img src={item.picture.url} alt={item.picture.alt} /> : <SVGDefault />}
                    <RichText
                        tagName="div"
                        className={style.libelle}
                        placeholder={'...'}
                        formattingControls={[]}
                        value={item.libelle}
                        onChange={(value) => updateValue('libelle', value, i)}
                    />
                </div>
                <div className={style.actions}>
                    <MediaUploadCheck>
                        <MediaUpload
                            allowedTypes={["image"]}
                            value={item.picture ? item.picture.id : null}
                            render={({ open }) => (
                                <button className={style.backgroundImage} onClick={open}>Modifier l'image</button>
                            )}
                            onSelect={ ( media ) => updateValue('picture', media, i) }
                        />
                    </MediaUploadCheck>
                    <button className={style.deleteButton} onClick={() => deleteSlide(i)}>
                        <svg aria-hidden="true" role="img" focusable="false" class="dashicon dashicons-trash" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path d="M12 4h3c.6 0 1 .4 1 1v1H3V5c0-.6.5-1 1-1h3c.2-1.1 1.3-2 2.5-2s2.3.9 2.5 2zM8 4h3c-.2-.6-.9-1-1.5-1S8.2 3.4 8 4zM4 7h11l-.9 10.1c0 .5-.5.9-1 .9H5.9c-.5 0-.9-.4-1-.9L4 7z"></path>
                        </svg>
                    </button>
                    <button className={style.addButton} onClick={() => addElement()}>
                        <svg aria-hidden="true" role="img" focusable="false" class="dashicon dashicons-insert" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path d="M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z"></path>
                        </svg>
                    </button>
                    <hr />
                </div>
            </div>
        ))}

        {
            /* Front */
            !isEditing && svgLibelle.map((item, i) => (
                <div className={style.content} key={i}>
                    {item.picture && <img src={item.picture.url} alt={item.picture.alt}/>}
                    <div className={style.libelle} dangerouslySetInnerHTML={{__html: item.libelle}}></div>
                </div>
            ))
        }
    </div>
}